import { Button } from "@/components/button";
import { FONT } from "@/styles/common";
import { Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomButton = styled(Button)`
    width: 36px;
    height: 36px;
    padding: 0;
    border: 1px solid ${({ theme }) => theme.COLOR.gray[400]};

    &:hover {
        background: ${({ theme }) => theme.COLOR.gray[100]};
    }
`;

export const CustomText = styled(Text)`
    ${FONT("pretendard", 16, 500)}
`;
